import axios from "axios";
import { freshingBoxLabels, freshingBoxOrder } from "../../urls";

export const sendOrderToFreshingBox = async (order, token) => {
  try {
    const response = await axios.post(
      freshingBoxOrder,
      { order },
      {
        headers: { Authorization: token },
      },
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    console.error("Freshingbox API error:", error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
    };
  }
};

export const getFreshingBoxLabels = async (orderId, token) => {
  try {
    const response = await axios.post(
      freshingBoxLabels,
      { orderId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        responseType: "blob",
      },
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    console.error("Freshingbox labels API error:", error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
    };
  }
};
